// @ts-nocheck
import { scrollTo } from '../../../shared/utils/scrollTo';
import { HTML_ID_SCROLLTO_AREA } from '../config';

export function scrollToFocusArea() {
  const tables = document.getElementById(HTML_ID_SCROLLTO_AREA);
  if (tables) {
    scrollTo(tables);
  }
}
